// @ts-check
import { CircleIcon } from 'preferral-ui/components/CircleIcon';
import { Modal, ModalHeader } from 'preferral-ui/components/Modal';
import React from 'react';

/** @typedef {{
  isOpen: boolean;
  onClose(): void;
  customHelpWidget?: string;
}} HelpModalProps */

/** @type { React.FC<HelpModalProps> } */
export const HelpModal = (props) => {
  const { isOpen, onClose, customHelpWidget } = props;

  return customHelpWidget === 'bhnyc' ? (
    <Modal isOpen={isOpen} onRequestClose={onClose} className="max-w-3xl">
      <ModalHeader icon="question" title="Help Resources" onClose={onClose} />
      <div className="w-md flex px-4 pt-3 pb-6 space-x-3">
        <div className="flex-1">
          <h4 className="py-2 text-xl font-bold text-gray-700">
            For Internal User
          </h4>
          <h5 className="py-3 text-lg font-semibold text-gray-600">
            Training Materials
          </h5>
          <div className="p-3">
            <a
              href="https://www.preferral.com/guides/getting-started/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 hover:shadow-md flex items-center p-2 text-lg font-semibold text-blue-600 bg-white border border-blue-400 rounded"
            >
              <CircleIcon icon="play-circle" className="flex-shrink-0" />
              <span className="ml-2">Launch "How-To" Video Page</span>
            </a>
          </div>

          <div className="p-3">
            <a
              href="https://preferral-support.s3.amazonaws.com/BHNYC+-+Agency+User+Guide+(4).pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 hover:shadow-md flex items-center p-2 text-lg font-semibold text-blue-600 bg-white border border-blue-400 rounded"
            >
              <CircleIcon icon="file-alt" className="flex-shrink-0" />
              <span className="ml-2">Open User Guide</span>
            </a>
          </div>

          <h5 className="py-3 text-lg font-semibold text-gray-600">
            Contact Support
          </h5>
          <p className="px-2 mt-3">
            If you experience difficulties, please contact your “Super User” to
            see if they can provide assistance.
          </p>
          <p className="px-2 mt-3">
            If further assistance is needed, your agency’s super user is asked
            to email Dana at{' '}
            <a href="mailto:dana.calderone@bhnycipa.com">
              dana.calderone@bhnycipa.com
            </a>
          </p>
          <p className="px-2 mt-3">
            If the issue is more technical, please email:{' '}
            <a href="mailto:support@informd.ai">support@informd.ai</a> and the
            InforMD team will provide assistance in a timely manner.
          </p>
        </div>

        <div className="flex-1">
          <h4 className="py-2 text-xl font-bold text-gray-700">
            For External Users
          </h4>

          <h5 className="py-3 text-lg font-semibold text-gray-600">
            Hospital, Medical Office and or Primary Care
          </h5>
          <div className="p-3">
            <a
              href="https://www.loom.com/share/e47d587b892c4329be5a153d45bccb3e"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 hover:shadow-md flex items-center p-2 text-lg font-semibold text-blue-600 bg-white border border-blue-400 rounded"
            >
              <CircleIcon icon="play-circle" className="flex-shrink-0" />
              <div className="ml-2">
                <p>Launch External User Video</p>
                <p className="text-base font-normal">
                  (For Hospitals/Provider Offices)
                </p>
              </div>
            </a>
          </div>
          <div className="p-3">
            <a
              href="https://preferral-support.s3.amazonaws.com/BHNYC+Referral+Guide+-+Hospital%2C+Medical+Office+and+or+Primary+Care.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 hover:shadow-md flex items-center p-2 text-lg font-semibold text-blue-600 bg-white border border-blue-400 rounded"
            >
              <CircleIcon icon="file-alt" className="flex-shrink-0" />
              <div className="ml-2">
                <p>External User Guide</p>
                <p className="text-base font-normal">
                  (For Hospitals/Provider Offices)
                </p>
              </div>
            </a>
          </div>

          <h5 className="py-3 text-lg font-semibold text-gray-600">
            Community Based Organizations, Schools, and other Governmental
            agencies
          </h5>
          <div className="p-3">
            <a
              href="https://www.loom.com/share/f759a74ca8624d179feaf60fe208e7da"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 hover:shadow-md flex items-center p-2 text-lg font-semibold text-blue-600 bg-white border border-blue-400 rounded"
            >
              <CircleIcon icon="play-circle" className="flex-shrink-0" />
              <div className="ml-2">
                <p>Launch External User Video</p>
                <p className="text-base font-normal">(For CBOs etc.)</p>
              </div>
            </a>
          </div>
          <div className="p-3">
            <a
              href="https://preferral-support.s3.amazonaws.com/BHNYC+Referral+Guide+-+Community+Based+Organizations%2C+Schools%2C+and+other+Governmental+agencies.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:border-blue-500 hover:bg-blue-50 hover:text-blue-700 hover:shadow-md flex items-center p-2 text-lg font-semibold text-blue-600 bg-white border border-blue-400 rounded"
            >
              <CircleIcon icon="file-alt" className="flex-shrink-0" />
              <div className="ml-2">
                <p>External User Guide</p>
                <p className="text-base font-normal">(For CBOs etc.)</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </Modal>
  ) : null;
};
